import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Colorado Springs Portal": {
    parameters: {
      linkUrls: [
        "https://hammers.coloradosprings.gov/hammers/account/login.aspx",
      ],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
      includeFireDistricts: [
        {
          id: "F3660",
          name: "Colorado Springs Fire Dept",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "CO",
  },
  "Colorado Tier2 Submit": {
    parameters: {
      linkUrls: [
        "https://ceos.colorado.gov/CO/CEOS/Public/Client/CO_CIMPLE/Shared/Pages/Main/Login.aspx",
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          receipt: true,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "CO",
  },
  "Colorado Tier2 Submit - Revision": {
    parameters: {
      linkUrls: [
        "https://ceos.colorado.gov/CO/CEOS/Public/Client/CO_CIMPLE/Shared/Pages/Main/Login.aspx",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          receipt: false,
          submission: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "CO",
  },
};
